import JSscriptTag from '@ulta/core/components/JSscriptTag/JSscriptTag';

export default JSscriptTag;
